import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
export default function Follower(t0) {
  const $ = _c(14);
  const {
    follower
  } = t0;
  let t1;
  if ($[0] !== follower.identity.handle || $[1] !== follower.identity.pfp) {
    t1 = <div className="tw-h-10 tw-w-10 tw-bg-iron-800 tw-relative tw-flex-shrink-0 tw-rounded-lg"><div className="tw-rounded-lg tw-h-full tw-w-full"><div className="tw-ring-1 tw-ring-inset tw-ring-white/5 tw-h-full tw-w-full tw-max-w-full tw-rounded-lg tw-overflow-hidden tw-bg-iron-800"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-overflow-hidden">{follower.identity.pfp ? <img src={follower.identity.pfp} alt={`${follower.identity.handle}'s profile`} className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" /> : <div className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" />}</div></div></div></div>;
    $[0] = follower.identity.handle;
    $[1] = follower.identity.pfp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== follower.identity.level) {
    t2 = <UserCICAndLevel level={follower.identity.level} size={UserCICAndLevelSize.SMALL} />;
    $[3] = follower.identity.level;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `/${follower.identity.handle}`;
  let t4;
  if ($[5] !== follower.identity.handle || $[6] !== t3) {
    t4 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold tw-text-iron-50"><Link href={t3} className="tw-no-underline hover:tw-underline hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{follower.identity.handle}</Link></p>;
    $[5] = follower.identity.handle;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="tw-flex tw-flex-col"><div className="tw-flex tw-items-center tw-gap-x-1"><div className="tw-items-center tw-flex tw-gap-x-2">{t2}{t4}</div></div></div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-x-3">{t1}{t5}</div>;
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}